interface OpeningHours {
    day: string;
    hours: string;
}

interface LocationData {
    name: string;
    address: string;
    phone: string;
    email: string;
    mapUrl: string;
    directionsUrl: string;
}

interface LocationConfig {
    locationData: LocationData;
    openingHours: OpeningHours[];
    nearby?: string[];
}

// Default opening hours (used for most locations)
const standardOpeningHours: OpeningHours[] = [
    { day: "Monday", hours: "9:00 AM - 5:30 PM" },
    { day: "Tuesday", hours: "9:00 AM - 5:30 PM" },
    { day: "Wednesday", hours: "9:00 AM - 5:30 PM" },
    { day: "Thursday", hours: "9:00 AM - 5:30 PM" },
    { day: "Friday", hours: "9:00 AM - 5:30 PM" },
    { day: "Saturday", hours: "9:00 AM - 1:00 PM" },
    { day: "Sunday", hours: "Closed" }
];

// Extended hours for some locations
const extendedOpeningHours: OpeningHours[] = [
    { day: "Monday", hours: "9:00 AM - 5:30 PM" },
    { day: "Tuesday", hours: "9:00 AM - 5:30 PM" },
    { day: "Wednesday", hours: "9:00 AM - 5:30 PM" },
    { day: "Thursday", hours: "9:00 AM - 5:30 PM" },
    { day: "Friday", hours: "9:00 AM - 5:30 PM" },
    { day: "Saturday", hours: "9:00 AM - 1:00 PM" },
    { day: "Sunday", hours: "Closed" }
];

export const locationConfigs: Record<string, LocationConfig> = {
    broadmeadows: {
        locationData: {
            name: "Y3 Smiles Dental",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"

        },
        openingHours: standardOpeningHours
    },

    glenroy: {
        locationData: {
            name: "Y3 Smiles Dental - Glenroy Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    greenvale: {
        locationData: {
            name: "Y3 Smiles Dental - Greenvale Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: extendedOpeningHours
    },

    campbellfield: {
        locationData: {
            name: "Y3 Smiles Dental - Campbellfield Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    "meadow-heights": {
        locationData: {
            name: "Y3 Smiles Dental - Meadow Heights Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    "roxburgh-park": {
        locationData: {
            name: "Y3 Smiles Dental - Roxburgh Park Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: extendedOpeningHours
    },

    craigieburn: {
        locationData: {
            name: "Y3 Smiles Dental - Craigieburn Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: extendedOpeningHours
    },

    westmeadows: {
        locationData: {
            name: "Y3 Smiles Dental - Westmeadows Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    mickleham: {
        locationData: {
            name: "Y3 Smiles Dental - Mickleham Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    fawkner: {
        locationData: {
            name: "Y3 Smiles Dental - Fawkner Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    "gladstone-park": {
        locationData: {
            name: "Y3 Smiles Dental - Gladstone Park Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: extendedOpeningHours
    },

    hadfield: {
        locationData: {
            name: "Y3 Smiles Dental - Hadfield Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },

    dallas: {
        locationData: {
            name: "Y3 Smiles Dental - Dallas Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    jacana: {
        locationData: {
            name: "Y3 Smiles Dental - Jacana Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    coolaroo: {
        locationData: {
            name: "Y3 Smiles Dental - Coolaroo Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "oak-park": {
        locationData: {
            name: "Y3 Smiles Dental - Oak Park Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "pascoe-vale": {
        locationData: {
            name: "Y3 Smiles Dental - Pascoe Vale Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "pascoe-vale-south": {
        locationData: {
            name: "Y3 Smiles Dental - Pascoe Vale South Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    strathmore: {
        locationData: {
            name: "Y3 Smiles Dental - Strathmore Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "strathmore-heights": {
        locationData: {
            name: "Y3 Smiles Dental - Strathmore Heights Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    gowanbrae: {
        locationData: {
            name: "Y3 Smiles Dental - Gowanbrae Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    tullamarine: {
        locationData: {
            name: "Y3 Smiles Dental - Tullamarine Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "airport-west": {
        locationData: {
            name: "Y3 Smiles Dental - Airport West Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    niddrie: {
        locationData: {
            name: "Y3 Smiles Dental - Niddrie Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "essendon-north": {
        locationData: {
            name: "Y3 Smiles Dental - Essendon North Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "essendon-fields": {
        locationData: {
            name: "Y3 Smiles Dental - Essendon Fields Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    reservoir: {
        locationData: {
            name: "Y3 Smiles Dental - Reservoir Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "coburg-north": {
        locationData: {
            name: "Y3 Smiles Dental - Coburg North Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    coburg: {
        locationData: {
            name: "Y3 Smiles Dental - Coburg Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "brunswick-west": {
        locationData: {
            name: "Y3 Smiles Dental - Brunswick West Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    brunswick: {
        locationData: {
            name: "Y3 Smiles Dental - Brunswick Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    thornbury: {
        locationData: {
            name: "Y3 Smiles Dental - Thornbury Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    preston: {
        locationData: {
            name: "Y3 Smiles Dental - Preston Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    lalor: {
        locationData: {
            name: "Y3 Smiles Dental - Lalor Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    thomastown: {
        locationData: {
            name: "Y3 Smiles Dental - Thomastown Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    bundoora: {
        locationData: {
            name: "Y3 Smiles Dental - Bundoora Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    greensborough: {
        locationData: {
            name: "Y3 Smiles Dental - Greensborough Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    viewbank: {
        locationData: {
            name: "Y3 Smiles Dental - Viewbank Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "heidelberg-west": {
        locationData: {
            name: "Y3 Smiles Dental - Heidelberg West Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "heidelberg-heights": {
        locationData: {
            name: "Y3 Smiles Dental - Heidelberg Heights Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    ivanhoe: {
        locationData: {
            name: "Y3 Smiles Dental - Ivanhoe Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    "ivanhoe-east": {
        locationData: {
            name: "Y3 Smiles Dental - Ivanhoe East Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    yallambie: {
        locationData: {
            name: "Y3 Smiles Dental - Yallambie Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    macleod: {
        locationData: {
            name: "Y3 Smiles Dental - Macleod Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    kalkallo: {
        locationData: {
            name: "Y3 Smiles Dental - Kalkallo Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    attwood: {
        locationData: {
            name: "Y3 Smiles Dental - Attwood Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    somerton: {
        locationData: {
            name: "Y3 Smiles Dental - Somerton Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    },
    upfield: {
        locationData: {
            name: "Y3 Smiles Dental - Upfield Area",
            address: "Unit 1, 34 King William St, Broadmeadows, VIC 3047",
            phone: "03 9022 4442",
            email: "smile@y3smilesdental.com.au",
            mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d101047.34713583598!2d144.8419854!3d-37.6790611!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x402afaaf25bce177%3A0xf39d81248d24a91d!2sY3%20Smiles%20Dental!5e0!3m2!1sen!2sbd!4v1760793998614!5m2!1sen!2sbd",
            directionsUrl: "https://maps.app.goo.gl/XCeiAYziTDqGdJpc8"
        },
        openingHours: standardOpeningHours
    }
};

export type { LocationData, OpeningHours, LocationConfig };

// Adjacency map: for each suburb slug, list 4–6 geographically nearby suburb slugs.
export const nearbySuburbs: Record<string, string[]> = {
  // 12 primary suburbs
  broadmeadows:       ['glenroy', 'campbellfield', 'meadow-heights', 'westmeadows', 'gladstone-park', 'fawkner'],
  glenroy:            ['broadmeadows', 'fawkner', 'hadfield', 'oak-park', 'pascoe-vale', 'gowanbrae'],
  craigieburn:        ['mickleham', 'roxburgh-park', 'kalkallo', 'greenvale', 'meadow-heights', 'somerton'],
  greenvale:          ['attwood', 'roxburgh-park', 'meadow-heights', 'gladstone-park', 'tullamarine', 'westmeadows'],
  campbellfield:      ['broadmeadows', 'fawkner', 'coolaroo', 'somerton', 'dallas', 'jacana'],
  'roxburgh-park':    ['greenvale', 'meadow-heights', 'craigieburn', 'coolaroo', 'somerton', 'dallas'],
  'meadow-heights':   ['broadmeadows', 'roxburgh-park', 'greenvale', 'westmeadows', 'gladstone-park', 'coolaroo'],
  hadfield:           ['glenroy', 'fawkner', 'pascoe-vale', 'oak-park', 'coburg-north', 'broadmeadows'],
  westmeadows:        ['broadmeadows', 'gladstone-park', 'tullamarine', 'meadow-heights', 'attwood', 'greenvale'],
  'gladstone-park':   ['westmeadows', 'tullamarine', 'broadmeadows', 'meadow-heights', 'greenvale', 'gowanbrae'],
  fawkner:            ['glenroy', 'campbellfield', 'hadfield', 'coburg-north', 'broadmeadows', 'jacana'],
  mickleham:          ['craigieburn', 'kalkallo', 'roxburgh-park', 'greenvale', 'somerton', 'attwood'],
  // Secondary suburbs
  dallas:             ['campbellfield', 'broadmeadows', 'coolaroo', 'jacana', 'roxburgh-park', 'fawkner'],
  jacana:             ['fawkner', 'campbellfield', 'broadmeadows', 'dallas', 'coolaroo', 'hadfield'],
  coolaroo:           ['broadmeadows', 'meadow-heights', 'roxburgh-park', 'dallas', 'campbellfield', 'somerton'],
  'oak-park':         ['glenroy', 'hadfield', 'pascoe-vale', 'strathmore', 'broadmeadows', 'pascoe-vale-south'],
  'pascoe-vale':      ['glenroy', 'hadfield', 'oak-park', 'strathmore', 'coburg-north', 'broadmeadows'],
  'pascoe-vale-south':['pascoe-vale', 'oak-park', 'strathmore', 'coburg-north', 'coburg', 'hadfield'],
  strathmore:         ['strathmore-heights', 'pascoe-vale', 'oak-park', 'glenroy', 'broadmeadows', 'gowanbrae'],
  'strathmore-heights':['strathmore', 'gowanbrae', 'westmeadows', 'gladstone-park', 'tullamarine', 'broadmeadows'],
  gowanbrae:          ['glenroy', 'strathmore', 'strathmore-heights', 'gladstone-park', 'tullamarine', 'broadmeadows'],
  tullamarine:        ['westmeadows', 'gladstone-park', 'gowanbrae', 'strathmore-heights', 'airport-west', 'greenvale'],
  'airport-west':     ['tullamarine', 'gladstone-park', 'niddrie', 'essendon-north', 'essendon-fields', 'westmeadows'],
  niddrie:            ['airport-west', 'essendon-north', 'essendon-fields', 'tullamarine', 'gladstone-park', 'gowanbrae'],
  'essendon-north':   ['niddrie', 'airport-west', 'essendon-fields', 'strathmore', 'broadmeadows', 'gladstone-park'],
  'essendon-fields':  ['airport-west', 'niddrie', 'essendon-north', 'tullamarine', 'westmeadows', 'strathmore'],
  reservoir:          ['coburg-north', 'coburg', 'thornbury', 'preston', 'fawkner', 'hadfield'],
  'coburg-north':     ['coburg', 'fawkner', 'hadfield', 'reservoir', 'pascoe-vale-south', 'pascoe-vale'],
  coburg:             ['coburg-north', 'brunswick-west', 'brunswick', 'reservoir', 'fawkner', 'thornbury'],
  'brunswick-west':   ['coburg', 'brunswick', 'strathmore', 'broadmeadows', 'fawkner', 'glenroy'],
  brunswick:          ['brunswick-west', 'coburg', 'thornbury', 'reservoir', 'coburg-north', 'broadmeadows'],
  thornbury:          ['reservoir', 'coburg', 'brunswick', 'preston', 'broadmeadows', 'fawkner'],
  preston:            ['reservoir', 'thornbury', 'broadmeadows', 'fawkner', 'coburg', 'lalor'],
  lalor:              ['thomastown', 'bundoora', 'reservoir', 'broadmeadows', 'craigieburn', 'preston'],
  thomastown:         ['lalor', 'bundoora', 'reservoir', 'broadmeadows', 'greensborough', 'craigieburn'],
  bundoora:           ['thomastown', 'lalor', 'greensborough', 'viewbank', 'broadmeadows', 'craigieburn'],
  greensborough:      ['bundoora', 'viewbank', 'macleod', 'yallambie', 'broadmeadows', 'thomastown'],
  viewbank:           ['greensborough', 'macleod', 'yallambie', 'bundoora', 'heidelberg-west', 'broadmeadows'],
  'heidelberg-west':  ['viewbank', 'macleod', 'yallambie', 'heidelberg-heights', 'ivanhoe', 'broadmeadows'],
  'heidelberg-heights':['heidelberg-west', 'viewbank', 'ivanhoe', 'yallambie', 'macleod', 'broadmeadows'],
  ivanhoe:            ['ivanhoe-east', 'heidelberg-heights', 'heidelberg-west', 'yallambie', 'macleod', 'broadmeadows'],
  'ivanhoe-east':     ['ivanhoe', 'heidelberg-heights', 'viewbank', 'yallambie', 'macleod', 'broadmeadows'],
  yallambie:          ['viewbank', 'macleod', 'greensborough', 'heidelberg-heights', 'bundoora', 'broadmeadows'],
  macleod:            ['yallambie', 'greensborough', 'viewbank', 'heidelberg-west', 'bundoora', 'broadmeadows'],
  kalkallo:           ['craigieburn', 'mickleham', 'attwood', 'somerton', 'roxburgh-park', 'greenvale'],
  attwood:            ['greenvale', 'westmeadows', 'mickleham', 'kalkallo', 'meadow-heights', 'roxburgh-park'],
  somerton:           ['craigieburn', 'campbellfield', 'roxburgh-park', 'coolaroo', 'dallas', 'kalkallo'],
  upfield:            ['coburg-north', 'fawkner', 'campbellfield', 'broadmeadows', 'coburg', 'hadfield'],
};